import { FormSpy } from "react-final-form";
import "react18-json-view/src/style.css";
import JsonPreview from "../../common/JsonPreview";
import TitledCard from "../../ui/TitledCard/TitledCard";

const RffFormSpy = ({ formSpy }) => {
  if (!formSpy) {
    return null;
  }
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => (
        <TitledCard
          title="Form Data Preview"
          cardSx={{
            mt: 2,
            ".json-view": {
              div: {
                margin: "3px 0",
              },
            },
          }}
        >
          <JsonPreview
            values={values}
            //
            // theme="atom"
            // enableClipboard
            // displaySize
          />
        </TitledCard>
      )}
    </FormSpy>
  );
  // return <FormSpy subscription={{ values: true }}>{({ values }) => <FormResults values={values} />}</FormSpy>;
};
export default RffFormSpy;
